import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IRlmCredentials {
    username: string,
    key: string,
    customer_code: string,
    store_number: string,
    url_prefix: string,
}

class RlmCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IRlmCredentials = {} as IRlmCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }
    public get key() { return this._changes.key; }
    public get customer_code() { return this._changes.customer_code; }
    public get store_number() { return this._changes.store_number; }
    public get url_prefix() { return this._changes.url_prefix; }

    public set username(v: string) { this._changes.username = v; }
    public set key(v: string) { this._changes.key = v; }
    public set customer_code(v: string) { this._changes.customer_code = v; }
    public set store_number(v: string) { this._changes.store_number = v; }
    public set url_prefix(v: string) { this._changes.url_prefix = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IRlmCredentials;
    }

    public getUpdatedModel(): IRlmCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default RlmCredentialsStore;
